import { FC } from 'react';

import * as Sentry from '@sentry/browser';

import { ServiceType } from '../../enums/ServiceType';
import ContactInfo from '../../interfaces/ContactInfo';
import DeliveryService from '../../interfaces/DeliveryService';

import CollectComponent from './CollectComponent';
import HomeDeliveryInfo from './HomeDeliveryInfo';

interface IDeliveryInfoProps {
  shippingContact: ContactInfo;
  deliveryServices: DeliveryService[];
  showOpeningHours?: boolean;
}

const DeliveryInfo: FC<IDeliveryInfoProps> = ({
  shippingContact,
  deliveryServices,
  showOpeningHours = false,
}) => {
  function renderService(deliveryService: DeliveryService) {
    switch (deliveryService.serviceType) {
      case ServiceType.HomeDelivery:
        return (
          <HomeDeliveryInfo
            key={deliveryService.serviceItemNo}
            deliveryService={deliveryService}
            shippingContact={shippingContact}
          />
        );

      case ServiceType.ClickCollectStore:
      case ServiceType.Collect:
      case ServiceType.PickupPoint:
      case ServiceType.PickupPointExternal:
      case ServiceType.Locker:
      case ServiceType.ClickCollect:
        return (
          <CollectComponent
            key={deliveryService.serviceItemNo}
            deliveryService={deliveryService}
            showOpeningHours={showOpeningHours}
          />
        );

      default:
        Sentry.captureMessage(`Unknown delivery service type ${deliveryService.serviceType}.`);
        return null;
    }
  }

  return <div className="DeliveryInfo text-s">{deliveryServices.map(renderService)}</div>;
};

export default DeliveryInfo;
